import React, { useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { timeOptions, timeToIso8601 } from "./timeOptions";
import {PopOver} from "../../components/PopOver";
import {FormField} from "../../components/FormField";

export const DaysWeek = ({
    title,
    dayName,
    weekday,
    isArchived,
    isAllDisabled,
    times,
    setTimes,
}) => {
    const { t } = useTranslation();
    const currentTime = times.find((time) => time.weekday === weekday);

    const customSelectStyles = {
        input: (base) => ({
            ...base,
            boxShadow: "none !important",
            "*": {
                boxShadow: "none !important",
                outline: "none !important",
            },
        }),
        dropdownIndicator: base => ({
            ...base,
            color: "rgb(157, 157, 157) !important"
        })
    };

    const setValue = (value, name) => {
        const newTimes = times.map((time) => {
            if (time.weekday === weekday) {
                return {
                    ...time,
                    [name]: value,
                };
            }
            return time;
        });
        setTimes("times", newTimes);
    };

    const onActivateWeekday = () => {
        if (currentTime) {
            const filteredTimes = times.filter(
                (time) => time.weekday !== weekday
            );
            setTimes("times", filteredTimes);
        } else {
            const newTimes = [
                ...times,
                { weekday, start_time: "", end_time: "" },
            ];
            setTimes("times", newTimes);
        }
    };

    const startTime = currentTime?.start_time
        ? { label: timeToIso8601(currentTime.start_time) }
        : null;
    const endTime = currentTime?.end_time
        ? { label: timeToIso8601(currentTime.end_time) }
        : null;

    return (
        <div className="flex justify-between items-center gap-2 mb-3.5">
            <button
                type="button"
                disabled={isArchived}
                onClick={onActivateWeekday}
                className={`w-11 h-10 mt-0.5 inline-flex justify-center items-center px-3 text-sm font-bold rounded-md hover:bg-purple-200 hover:text-black border-2 border-purple-500 shadow-sm ${
                    isArchived && "cursor-not-allowed"
                } ${!currentTime ? "bg-white" : "bg-purple-500 text-white"}`}
            >
                {title}
            </button>

            <FormField disabled={isArchived}>
                <Select
                    options={timeOptions}
                    value={startTime}
                    name={`${dayName}_start_time`}
                    isDisabled={!currentTime || isAllDisabled}
                    onChange={({ value }) => setValue(value, "start_time")}
                    placeholder={t("Select time")}
                    isSearchable={false}
                    styles={customSelectStyles}
                    className="h-9 w-[160px]"
                />
                {isAllDisabled && <PopOver>{t("menu is archived")}</PopOver>}
            </FormField>
            <FormField disabled={isArchived}>
                <Select
                    options={timeOptions}
                    name={`${dayName}_end_time`}
                    value={endTime}
                    isDisabled={!currentTime || isAllDisabled}
                    onChange={({ value }) => setValue(value, "end_time")}
                    placeholder={t("Select time")}
                    isSearchable={false}
                    styles={customSelectStyles}
                    className="h-9 w-[160px]"
                />
                {isAllDisabled && <PopOver>{t("menu is archived")}</PopOver>}
            </FormField>
        </div>
    );
};
